<template>
    <div class="shadow-box-wrapper">
			<div v-if="icon" class="icon-div"> 
				<ion-icon :name="icon[0]"/>
				<ion-icon class="minor-icon" v-if="icon.length > 1" :name="icon[1]"></ion-icon>
			</div>
    	<slot></slot>
    </div>  
</template>

<script>
    export default {
        data() {
            return {}
        },
        props: {
            icon: '',				
        },
        methods: {
					
        },
        computed: {
					
        },
				mounted() {
					
				}
    }
</script>

<style lang="scss" scoped>
    .shadow-box-wrapper {
			transition: 0.5s;
			border-radius: 20px !important;
			border: 1px solid var(--border) !important;
			background: var(--leftMenuColor);
			box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.07), 2px 2px 7px 0px rgba(0, 0, 0, 0.07), 10px 10px 14px 0px rgba(0, 0, 0, 0.06), 22px 22px 18px 0px rgba(0, 0, 0, 0.04), 39px 38px 22px 0px rgba(0, 0, 0, 0.01), 60px 60px 24px 0px rgba(0, 0, 0, 0.00) !important;
			min-height: 90px;
			min-width: 350px;

			.icon-div {
				position: relative;
				z-index: 1;
				.minor-icon {
					height: 14px;
					width: 13px;
					position: absolute;
					left: 13px;
					top: 4px;
					z-index: 10;
				}
			}
    }

		.advice-wrapper{
			display: flex;
		}
		
		ion-icon {
			height: 24px;
			width: 24px;
		}

		

</style>


// WEBPACK FOOTER //
// src/vue/views/components/layouts/shadowBox.vue